// extracted by mini-css-extract-plugin
export default {"formHolder":"Agreement_formHolder__UfhlK","cgv":"Agreement_cgv__FEz7n"};